import React from "react";
import Hero from "./Components/Hero.jsx"
import Gallery from "./Components/Gallery.jsx"
import Footer from "./Components/Footer.jsx"
import Navbar from "./Components/Navbar.jsx";
import Covers from "./Components/Covers.jsx"
//import PremiumCovers from "./Components/PremiumCovers.jsx"
import "./App.css"

import ScrollProgress from "./Widgets/ScrollProgress.jsx"
import FloatingButtons from "./Widgets/FloatingButtons.jsx"
import LoadingScreen from "./Components/LoadingScreen.jsx"
import Commemorative from "./Components/Commemorative.jsx";
import BioSection from "./Components/BioSection.jsx";
import Pricing from "./Components/Pricing.jsx";
import { Analytics } from "@vercel/analytics/react";

function App() {
  return (
    <LoadingScreen> 
    <div className="app">
      <Navbar/>
      <ScrollProgress />
      <Hero />
      <div className="section-separator"></div>
      <Gallery />
      <div className="section-separator"></div>
      <Covers/>
      <div className="section-separator"></div>
      <Commemorative/>
      <div className="section-separator"></div>
      <BioSection/>
      <div className="section-separator"></div>
      <Pricing />
      <FloatingButtons />
      <Footer />
      <Analytics />
    </div>
    </LoadingScreen>
  );
}

export default App;
